<template>
    <span class="billing-icon-tile" :class="toneClass">
        <v-icon size="24">{{ icon }}</v-icon>
    </span>
</template>

<script>
export default {
    name: 'BillingIconTile',
    props: {
        icon: {
            type: String,
            default: '$vuetify.icons.info',
        },
        tone: {
            type: String,
            default: 'blue',
        },
    },
    computed: {
        toneClass() {
            return `billing-icon-tile--${this.tone}`;
        },
    },
};
</script>

<style scoped>
.billing-icon-tile {
    align-items: center;
    border-radius: 8px;
    display: inline-flex;
    flex: 0 0 auto;
    height: 44px;
    justify-content: center;
    width: 44px;
}

.billing-icon-tile--blue {
    background: rgba(60, 100, 244, 0.18);
    color: #4d8dff;
}

.billing-icon-tile--cyan {
    background: rgba(1, 154, 226, 0.18);
    color: #37b7f4;
}

.billing-icon-tile--green {
    background: rgba(75, 200, 167, 0.18);
    color: #69d9b8;
}

.billing-icon-tile--orange {
    background: rgba(243, 165, 95, 0.2);
    color: #f3a55f;
}

.billing-icon-tile--purple {
    background: rgba(137, 99, 251, 0.2);
    color: #9c78ff;
}
</style>
